import React from "react";

const SuccessMsg = props => <div className="success-msg">{props.children}</div>;

export default SuccessMsg;
